<template>
    <div>
        <vs-button @click="enrollModal = true">Enroll</vs-button>

        <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="enrollModal" :class="{show: enrollModal}">
            <div style="width: 100% !important;" class="cstm-modal medium fixed_medium">
                <div class="header p-0">
                    <button @click.stop="enrollModal = false" class="close-modal">&times;</button>
                </div>
                <div style="height: auto; max-height: calc(100vh - 100px);" class="modal-content p-4">
                    <!-- step 1 -->
                    <div class="step_holder" v-if="step1Active">
                        <h4 class="text-center mb-4">Tell us when you are available?</h4>
                        <p class="text-center mb-4">Select preferred---Time</p>
                        <div class="flex flex-wrap justify-between items-center mb-4">
                            <label style="font-weight: 500;">Select Teacher</label>
                            <v-select style="min-width: 370px;" />
                        </div>
                        <div class="time_slot_holder">
                            <div class="each_time_slot" v-for="(time_slot, index) in time_slots" :key="index">
                                <div style="border-right: 1px solid #CAD8E0;" class="inline-flex items-center">
                                    <vs-checkbox />
                                    <div class="each_day">{{ time_slot. day }}</div>
                                </div>
                                <div class="inline-flex items-center">
                                    <vs-checkbox />
                                    <label>Any time</label>
                                </div>
                                <div class="inline-flex items-center">
                                    <span class="pr-1">From</span>
                                    <v-select style="width: 110px;" />
                                </div>
                                <div class="inline-flex items-center">
                                    <span class="pr-1">Untill</span>
                                    <v-select style="width: 110px;" />
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-wrap justify-center mt-4">
                            <vs-button @click="moveToStep2">Next</vs-button>
                        </div>
                    </div>
                    <!-- step 2 -->
                    <div class="step_holder" v-if="step2Active">
                        <h4 class="text-center mb-4">Your chosen schedule</h4>
                        <p class="text-center mb-4">Select preferred Time</p>
                        <div class="inline-flex items-center mb-4">
                            <img src="http://localhost:8080/img/user-circle-solid.c3580913.svg" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block">
                            <strong class="pl-2">Teacher Name</strong>
                        </div>
                        <vs-row>
                            <vs-col vs-lg="5" vs-sm="12" class="p-1">
                                <flat-pickr
                                    class="w-full mb-2"
                                    :config="config"     
                                ></flat-pickr>
                            </vs-col>
                            <vs-col vs-lg="7" vs-sm="12" class="px-4 py-1">
                                <h5 class="mb-4">Choose your available time slot</h5>
                                <div style="border-right: none;" class="time_zone_holder">
                                    {{timeSlot}}
                                    <template v-for="(eachtime, index) in availabilityTime">
                                    <vs-radio class="mr-2 mb-2" 
                                    :class="[eachtime.status == 'n/a' ? 'disabled' : '']"
                                    :disabled="eachtime.status == 'n/a'"
                                    :key="index"
                                    v-model="timeSlot"
                                    vs-name="timezone"
                                    :vs-value="eachtime.time">
                                        <div class="bg-grey">
                                            {{ eachtime.time }}
                                        </div>
                                    </vs-radio>
                                    <p v-if="availabilityTime.length == 0" style="opacity: 0.7;" :key="index">No dates selected yet</p>
                                    </template>
                                </div>
                            </vs-col>
                        </vs-row>
                        <div class="flex flex-wrap justify-center mt-4">
                            <vs-button type="border" class="mr-1" @click="backToStep1">Back</vs-button>
                            <vs-button class="ml-1" @click="moveToStep3">Next</vs-button>
                        </div>
                    </div>
                    <!-- step 3 -->
                    <div class="step_holder" v-if="step3Active">
                        <h4 class="text-center mb-4">Your chosen schedule</h4>
                        <p class="text-center mb-4">Select preferred Time</p>
                        <div class="light_blue_holder p-4">
                            <h5>Your all 10 sessions</h5>
                        </div>
                        <div class="cstm_vuexy_table table-responsible">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Session 1</td>
                                        <td>Monday</td>
                                        <td>14/6/2022</td>
                                        <td>16:30 - 17:00</td>
                                        <td style="width: 50px;">
                                            <vs-tooltip text="Due to holiday" position="top">
                                                <span class="material-icons-outlined">info</span>
                                            </vs-tooltip>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>    
                        <div class="flex flex-wrap justify-center mt-4">
                            <vs-button type="border" class="mr-1" @click="backToStep2">Back</vs-button>
                            <vs-button class="ml-1" @click="moveToStep4">Next</vs-button>
                        </div>                    
                    </div>
                    <!-- step 4 -->
                    <div class="step_holder" v-if="step4Active">
                        <h4 class="text-center mb-4">Where is your address?</h4>
                        <p class="text-center mb-4">Enter your address details</p>
                        <vs-row>
                        <vs-col vs-w="12" class="p-1">
                            <vs-input placeholder="Address Line 1" class="w-full" />
                        </vs-col>
                        <vs-col vs-w="12" class="p-1">
                            <vs-input placeholder="Address Line 2" class="w-full" />
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <vs-input placeholder="City" class="w-full" />
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <vs-input placeholder="State/Province/Region" class="w-full" />
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <vs-input placeholder="ZIP Code" class="w-full" />
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <v-select
                            placeholder="Country"
                            class="w-full"
                            />
                        </vs-col>
                        </vs-row>
                        <vs-button class="block m-auto mt-4" @click="moveToStep5">Next</vs-button>
                    </div>
                    <!-- step 5 -->
                    <div class="step_holder" v-if="step5Active">
                        <h4 class="text-center mb-4">Confirm your course details</h4>
                        <div class="grey_border mb-4">
                        <div class="light_blue_holder text-center p-4">Course Name</div>
                        <h4 class="text-center p-4">Piano course for bignners</h4>
                        </div>
                        <div class="grey_border p-4 mb-4">
                        <vs-row>
                            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <p>Student Name</p>
                            <strong>Evangeline Guerguis</strong>
                            </vs-col>
                            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <p>DOB</p>
                            <strong>28/02/2010</strong>
                            </vs-col>
                            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <p>Phone</p>
                            <strong>07971778039</strong>
                            </vs-col>
                            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <p>Email</p>
                            <strong>evangelineg@demail.com</strong>
                            </vs-col>
                            <vs-col vs-w="12" class="p-1">
                            <p>Parent/Payee</p>
                            <strong>Selvia Guerguis</strong>
                            </vs-col>
                        </vs-row>
                        </div>
                        <div class="grey_border p-4 mb-4">
                        <vs-row>
                            <vs-col vs-w="12" class="p-1">
                            <p>Teacher Name</p>
                            <strong>Joanna Laboga</strong>
                            </vs-col>
                            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <p>Day</p>
                            <strong>Monday</strong>
                            </vs-col>
                            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <p>Time</p>
                            <strong>15:30 - 16:00</strong>
                            </vs-col>
                            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <p>First Lesson Date</p>
                            <strong>10/06/2022</strong>
                            </vs-col>
                            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                            <p>Last Lesson Date</p>
                            <strong>10/08/2022</strong>
                            </vs-col>
                        </vs-row>              
                        </div>
                        <div class="grey_border p-4 mb-4">
                            <vs-row>
                                <vs-col vs-lg="6" vs-sm="12" class="p-1">
                                    <p>Course Pricing</p>
                                    <strong>Recurring</strong>
                                </vs-col>
                                <vs-col vs-lg="6" vs-sm="12" class="p-1">
                                    <p>Total Price</p>
                                    <strong>£100.00</strong>
                                </vs-col>
                                <vs-col vs-lg="6" vs-sm="12" class="p-1">
                                    <p>Payment Cycle</p>
                                    <strong>Every 1 month</strong>
                                </vs-col>
                                <vs-col vs-lg="6" vs-sm="12" class="p-1">
                                    <p>No. of Installment</p>
                                    <strong>3</strong>
                                </vs-col>
                                <vs-col vs-lg="6" vs-sm="12" class="p-1">
                                    <p>First payment date</p>
                                    <strong>10/06/2022</strong>
                                </vs-col>
                                <vs-col vs-lg="6" vs-sm="12" class="p-1">
                                    <p>Last payment date</p>
                                    <strong>10/08/2022</strong>
                                </vs-col>
                            </vs-row>              
                        </div>
                        <div class="flex flex-wrap justify-center mt-4">
                            <vs-button @click="moveToStep6">Go for payment</vs-button>
                        </div>
                    </div>
                    <!-- step 6 -->
                    <div class="step_holder" v-if="step6Active">
                        <h4 class="text-center mb-4">Payment Details</h4>
                        <div class="cstm_vuexy_table table-responsive">
                            <table>
                                <tbody>
                                    <tr class="light_blue_holder">
                                        <td><strong>Course fees</strong></td>
                                        <td><strong>£100.00</strong></td>
                                    </tr>
                                    <tr>
                                        <td>1st installment  09/06/2022</td>
                                        <td>£40.00</td>
                                    </tr>
                                    <tr>
                                        <td>2nd installment  09/07/2022</td>
                                        <td>£30.00</td>
                                    </tr>
                                    <tr>
                                        <td>3rd installment  09/08/2022</td>
                                        <td>£30.00</td>
                                    </tr>
                                </tbody>
                            </table>                            
                        </div>
                        <div class="my-6">
                            <vs-radio class="mr-4">Pay full course fees</vs-radio>
                            <vs-radio>Pay installment fees</vs-radio>
                        </div>
                        <div class="grey_border">
                            <div class="light_blue_holder p-4">
                                <h5>Choose payment getway</h5>
                            </div>
                            <div class="p-4">

                            </div>
                        </div>
                        <div class="flex flex-wrap justify-center mt-4">
                            <vs-button @click="moveToStep7">Book</vs-button>
                        </div>
                    </div>
                    <!-- step 7 -->
                    <div class="step_holder congrats_popup" v-if="step7Active">
                        <img src="@/assets/images/pages/congrats.png" alt="">
                        <p class="heading">Congratulations </p>
                        <p class="content">You have successfully enrolled on the course</p>
                        <p class="footer" @click="finishStep">Ok</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'paid-course',
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {
      enrollModal: false,
      step1Active: true,
      step2Active: false,
      step3Active: false,
      step4Active: false,
      step5Active: false,
      step6Active: false,
      step7Active: false,
      time_slots: [
        {
          id: 1,
          day: 'Monday'
        },
        {
          id: 2,
          day: 'Tuesday'
        },
        {
          id: 3,
          day: 'Wednesday'
        },
        {
          id: 4,
          day: 'Thursday'
        },
        {
          id: 5,
          day: 'Friday'
        },
        {
          id: 6,
          day: 'Saturday'
        },
        {
          id: 7,
          day: 'Sunday'
        }
      ],
      config: {
        inline: true       
      },
      timeSlot: '',
      availabilityTime: [
        {
          time: '09:30 - 10:00',
          status: 'n/a'
        },
        {
          time: '10:00 - 10:30'
        },
        {
          time: '10:30 - 11:00'
        },
        {
          time: '11:00 - 11:30'
        },
        {
          time: '11:30 - 12:00'
        },
        {
          time: '12:00 - 12:30'
        }
      ]
    }
  },
  methods: {
    moveToStep2 () {
      this.step1Active = false
      this.step2Active = true
    },
    moveToStep3 () {
      this.step2Active = false
      this.step3Active = true
    },
    moveToStep4 () {
      this.step3Active = false
      this.step4Active = true
    },
    moveToStep5 () {
      this.step4Active = false
      this.step5Active = true
    },
    moveToStep6 () {
      this.step5Active = false
      this.step6Active = true
    },
    moveToStep7 () {
      this.step6Active = false
      this.step7Active = true
    },
    finishStep () {
      this.enrollModal = false
      this.step7Active = false
      this.step1Active = true
    }
  }
}
</script>